import { createClient } from "@supabase/supabase-js";

export const SUPABASE_URL = "https://fxwphsbcdcqbsrjgbrcc.supabase.co";
const SUPABASE_KEY = "sb_publishable_kX2_bB4OjUJjRmUXbBr0tw_LAXysxiU";

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
